import { format } from "date-fns";
import { IzobrazevanjeDetailType } from "../../types/Izobrazevanje/IzobrazevanjeDetailType";
import styled from "styled-components";
import timezoneShift from "../../utils/TimezoneShift";
import { getPathWithBaseURL } from "../../utils/Common";
import { AuthContext } from "../../context/AuthContext";

const StyledIzobrazevanjeDetailForm = styled.div`
    h1, h3, p{
        font-weight: 350;
    }
    h1{
        font-size: 2rem;
        margin-top: 0;
        margin-bottom: 1rem;
    }
    h3{
        margin-top: 0;
        margin-bottom: 0.7rem;
    }
    p{
        margin-bottom: 0;
    }
    a {
        color:#397289;
            text-decoration:underline;
    }
            a:hover{
                text-decoration:none;
            }
    .desc{
        margin-bottom:1rem;
    }
    font-weight: 400;
    padding: 1.5rem;
    background-color: ${props => props.theme.colors.background};
    border: ${props => props.theme.colors.border} 1px solid;
    border-radius: 4px;
    width: 50%;
    margin-top:1rem;
    /* margin-bottom: 1rem; */
    @media (max-width: 900px){
        width: 90%;
    }
`

type IzobrazevanjeDetailFormArgs = {
    izobrazevanje: IzobrazevanjeDetailType;
}

const IzobrazevanjeDetailForm = ({ izobrazevanje }: IzobrazevanjeDetailFormArgs) => {
    return (
        <StyledIzobrazevanjeDetailForm className="card">
            <h1>{`${izobrazevanje.naziv}`}</h1>
            
            {izobrazevanje.opis &&
                <p className="desc">
                    {`${izobrazevanje.opis}`}
                </p>}
            <h3>Kategorija: <b>{`${izobrazevanje.izobrazevanjeTipNaziv}`}</b></h3>
            <h3>Predavatelj: <b>{izobrazevanje.predavatelj === null ? `/` : `${izobrazevanje.predavatelj}`} </b></h3>
            <h3>Trajanje: <b>{format(timezoneShift(new Date(izobrazevanje.datumCasOd)), 'dd.MM.yyyy, HH:mm')} - {format(timezoneShift(new Date(izobrazevanje.datumCasDo)), 'dd.MM.yyyy, HH:mm')}</b></h3>
            <h3>Na voljo za: 
                <b>{izobrazevanje.podrocja.map(item => ` ${item.naziv}`).join(`, `)}</b>
            </h3>
            <h3>Število točk: <b>{izobrazevanje.tockeSt == null ? `/` : `${izobrazevanje.tockeSt}`}</b></h3>
            {izobrazevanje.lokacijaVrsta &&
                <div>
                    <h3>Vrsta lokacije: <b> 
                            {{
                                1: "spletna povezava",
                                2: "fizična lokacija",
                                3: "eCampus"
                            }[izobrazevanje.lokacijaVrsta] || "neznano"}
                        </b>
                    </h3>
                        {{
                                1: (
                                    <h3>Lokacija podrobnosti: 
                                        <b>
                                            <a href={izobrazevanje.lokacijaPodrobnosti} target="_blank" rel="noreferrer">
                                                spletna povezava
                                            </a>
                                        </b>
                                    </h3>
                                ),
                                2: (
                                    <h3>Lokacija podrobnosti:
                                        <p>
                                            <b style={{ whiteSpace: "pre-line" }}>
                                                {izobrazevanje.lokacijaPodrobnosti}
                                            </b>
                                        </p>
                                    </h3>
                                ),
                                3: (
                                     <AuthContext.Consumer>
                                        {({ loggedInUser }) => (
                                            loggedInUser?.isAdministrator &&
                                            <h3>Lokacija podrobnosti: 
                                                <a href={izobrazevanje.eCourseURL || ""} target="_blank" rel="noreferrer">
                                                    eCampus
                                                </a>
                                            </h3>
                                        )}
                                    </AuthContext.Consumer>
                                )
                        }[izobrazevanje.lokacijaVrsta] || "neznano"}
                </div>
            }
        </StyledIzobrazevanjeDetailForm>
    );
}

export default IzobrazevanjeDetailForm;